import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const StockAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.stockAccess
        ? setValues((j) => ({
            ...j,
            stock: {
              create: true,
              edit: true,
              cancel: true,
              payment: true,
              status: true,
              labelPrint: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            stock: {
              create: false,
              edit: false,
              cancel: false,
              payment: false,
              status: false,
              labelPrint: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.stockAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      stock: { ...j.stock, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.stockAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.stock?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.stock?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Cancel"
          checked={values.stock?.cancel || false}
          name={"cancel"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Payment"
          checked={values.stock?.payment || false}
          name={"payment"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Status"
          checked={values.stock?.status || false}
          name={"status"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Label Print"
          checked={values.stock?.labelPrint || false}
          name={"labelPrint"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default StockAccess;
